import React from 'react'
import classNames from 'classnames'

import Link from '../Link'
import SiteMetadata from '../../query/siteMetadata'

const ITEM_CLASS_NAME = 'heimr-menu__item'
const ITEMS_CLASS_NAME = `${ITEM_CLASS_NAME}s`

const isPartiallyActive = ({ isPartiallyCurrent }) => {
  return isPartiallyCurrent
    ? { className: `${ITEM_CLASS_NAME} ${ITEM_CLASS_NAME}--partially-active` }
    : null
}

const isActive = ({ isCurrent }) => {
  return isCurrent
    ? { className: `${ITEM_CLASS_NAME} ${ITEM_CLASS_NAME}--active` }
    : null
}

const Item = ({ data, onNavigation }) => {
  // Support for partially active menu items
  const getProps = data.partiallyActive ? isPartiallyActive : isActive

  return (
    <Link
      to={data.link}
      className={ITEM_CLASS_NAME}
      onClick={onNavigation}
      getProps={getProps}
    >
      {data.title}
    </Link>
  )
}

const MenuItems = ({ items, onNavigation }) => (
  <div className={ITEMS_CLASS_NAME}>
    {items.map((menuItem, index) => (
      <Item data={menuItem} onNavigation={onNavigation} key={index} />
    ))}
  </div>
)

export default ({ onNavigation = () => {}, open = false, className }) => {
  const classes = classNames(
    'heimr-menu',
    className,
    open ? 'heimr-menu--open' : ''
  )

  return (
    <nav className={classes}>
      <MenuItems items={SiteMetadata().menuItems} onNavigation={onNavigation} />
    </nav>
  )
}
